module.exports = __webpack_public_path__ + "img/er.075f7d29.svg";